<thead class="table-head">
  <tr class="table-head-row" *ngIf="customActions || tableSearch || dynamicColumns || paginate || filter">
    <td *ngIf="tableSearch">
      <sp-input type="text" [placeholder]="'search table'" label="Search" [(ngModel)]="basicQuery"></sp-input>
    </td>
    <td [attr.colspan]="header && header.length ? header.length : 1">
      <div class="table-actions">
        <div class="table-actions-dynamicColumns" *ngIf="dynamicColumns">
          <sp-icon class="table-actions-dynamicColumns-icon" name="add-2" type="solid" size="small"></sp-icon>
        </div>
        <div class="table-actions-mutate" *ngIf="mutating">
          <button (click)="mutate('big')" [class.table-actions-mutate-button--active]="size === 'big'"
                  class="table-actions-mutate-button">
            <img src="/public/resources/images/icons/Table Density - big.svg"/>
          </button>
          <button
            (click)="mutate('normal')"
            [class.table-actions-mutate-button--active]="size === 'normal'"
            class="table-actions-mutate-button"
          >
            <img src="/public/resources/images/icons/Table Density - normal.svg"/>
          </button>
          <button
            (click)="mutate('small')"
            [class.table-actions-mutate-button--active]="size === 'small'"
            class="table-actions-mutate-button"
          >
            <img src="/public/resources/images/icons/Table Density - small.svg"/>
          </button>
        </div>
        <div class="table-actions-pagination" *ngIf="paginate">
          <div class="table-actions-pagination-buttons">
            <button
              [disabled]="!pagination.next || pagination.next === pagination.last + 1"
              class="table-actions-pagination-buttons-button"
              (click)="fetch('next')"
            >
              <img [src]="paginateIcons.next"/>
            </button>
            <button
              [disabled]="!pagination.prev || pagination.prev === 0"
              class="table-actions-pagination-buttons-button"
              (click)="fetch('previous')"
            >
              <img [src]="paginateIcons.prev"/>
            </button>
          </div>
          <div class="table-actions-pagination-meta">
            <div class="table-actions-pagination-meta-dropdown">
              <img class="table-actions-pagination-meta-dropdown-icon" [src]="paginateIcons.dropdown"/>
              <div class="table-actions-pagination-meta-dropdown-count">
                <button
                  class="table-actions-pagination-meta-dropdown-count-button"
                  (click)="fetch(null, 20)"
                  [class.--active]="pagination.pageSize === 20"
                >
                  20
                </button>
                <button
                  class="table-actions-pagination-meta-dropdown-count-button"
                  (click)="fetch(null, 50)"
                  [class.--active]="pagination.pageSize === 50"
                >
                  50
                </button>
                <button
                  class="table-actions-pagination-meta-dropdown-count-button"
                  (click)="fetch(null, 100)"
                  [class.--active]="pagination.pageSize === 100"
                >
                  100
                </button>
              </div>
            </div>
            <span class="table-actions-pagination-meta-data">
                {{ pagination.currentPage }} / {{ pagination.last }} , {{ pagination.totalItems }}
              </span>
          </div>
        </div>
        <div class="table-actions-filter" *ngIf="filter">
          <ng-template ngFor let-filterItem [ngForOf]="filterInputs">
            <sp-input
              *ngIf="filterItem.input === 'input' && !filterItem.hide"
              type="text"
              placeholder="search column"
              [(ngModel)]="basicQuery[filterItem.name]"
              [label]="filterItem.label"
              [value]="filterItem.value ? filterItem.value : null"
              (change)="filterItem.change ? filterItem.change($event) : null"
            ></sp-input>
            <sp-select
              *ngIf="filterItem.input === 'select' && !filterItem.hide"
              [(ngModel)]="basicQuery[filterItem.name]"
              [items]="filterItem.options"
              [placeholder]="filterItem.label"
              [selected]="filterItem.value ? filterItem.value : null"
              (onSelectChange)="filterItem.change ? filterItem.change($event) : null"
            ></sp-select>
            <sp-datepicker
              *ngIf="filterItem.input === 'date-picker' && !filterItem.hide"
              [(ngModel)]="basicQuery[filterItem.name]"
              [range]="true"
              [noValue]="true"
              (onDateChange)="changeDate($event)"
            ></sp-datepicker>
          </ng-template>
          <sp-button *ngIf="filterInputs" [style]="'ghost icon'" label="بحث" (clickAction)="fetch()"></sp-button>
        </div>
      </div>
    </td>
    <td [attr.colspan]="colspan" *ngIf="customActions">
      <div class="table-actions normal">
        <ng-content></ng-content>
      </div>
    </td>
  </tr>
</thead>
